module.exports = __webpack_public_path__ + "static/media/engine-oil-life.d9aec352.svg";